import { useEffect, useState } from "react";
import { apiGet } from "@/lib/apiAdmin";

const fmt = (n) => `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export const MoneyTrend = () => {
  const [days, setDays] = useState(null);
  const [hover, setHover] = useState(null);
  useEffect(() => { apiGet("/admin/money/daily", { days: 30 }).then((d) => setDays(d.days)).catch(() => setDays([])); }, []);
  if (!days) return null;
  const max = Math.max(1, ...days.map((d) => Math.max(d.made, d.spent)));
  const tot = days.reduce((a, d) => ({ made: a.made + d.made, spent: a.spent + d.spent }), { made: 0, spent: 0 });
  const h = hover !== null ? days[hover] : null;
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.02] p-5 space-y-3" data-testid="money-trend">
      <div className="flex flex-wrap items-center gap-3">
        <p className="text-white font-['Outfit'] flex-1">Last 30 days</p>
        <span className="flex items-center gap-1.5 text-xs text-gray-400"><span className="w-2.5 h-2.5 rounded-sm bg-emerald-400" />Made {fmt(tot.made)}</span>
        <span className="flex items-center gap-1.5 text-xs text-gray-400"><span className="w-2.5 h-2.5 rounded-sm bg-rose-400" />Spent {fmt(tot.spent)}</span>
      </div>
      <div className="relative h-40 flex items-end gap-[3px] sm:gap-1" onMouseLeave={() => setHover(null)}>
        {!tot.made && !tot.spent && <p className="absolute inset-0 flex items-center justify-center text-sm text-gray-500" data-testid="money-trend-empty">No money in or out in the last 30 days yet.</p>}
        {days.map((d, i) => (
          <div key={d.date} className="flex-1 h-full flex items-end gap-[1px] cursor-default" onMouseEnter={() => setHover(i)} onClick={() => setHover(i)} data-testid={`money-trend-day-${d.date}`}>
            <div className="flex-1 rounded-t-sm bg-emerald-400/80 transition-[height] duration-500" style={{ height: `${(d.made / max) * 100}%`, minHeight: d.made ? 2 : 0 }} />
            <div className="flex-1 rounded-t-sm bg-rose-400/70 transition-[height] duration-500" style={{ height: `${(d.spent / max) * 100}%`, minHeight: d.spent ? 2 : 0 }} />
          </div>
        ))}
        {h && (
          <div className="absolute -top-2 left-1/2 -translate-x-1/2 rounded-lg bg-black/90 border border-white/10 px-3 py-1.5 text-xs text-white whitespace-nowrap pointer-events-none" data-testid="money-trend-tip">
            {new Date(`${h.date}T12:00:00`).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })} · made {fmt(h.made)} · spent {fmt(h.spent)} · profit {fmt(h.made - h.spent)}
          </div>
        )}
      </div>
      <div className="flex justify-between text-[10px] text-gray-500">
        <span>{new Date(`${days[0].date}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</span><span>Today</span>
      </div>
    </div>
  );
};
